export const requiredField = (name?: string, message?: string) => ({
  required: true,
  message: name ? `Please input your ${name}!` : message,
});

const FormValidator = {
  email: [
    requiredField('email'),
    {
      type: 'email',
      message: "Niste unijeli ispravnu e-mail adresu!",
    },
  ],
  password: [
    requiredField('password'),
    {
      min: 6,
      message: "Niste unijeli ispravnu lozinku. Minimum je {0} znakova".replace('{0}', 6),
    },
  ],
  color: {
    pattern: /^#([0-9a-fA-F]{6})$/,
    message: "To mora biti heksadecimalni kod (na primjer: #FFFFFF)",
  },
};

export default FormValidator;



// WEBPACK FOOTER //
// ./src/models/formValidator.ts